import { render, staticRenderFns } from "./InstallAndUpdateManagement.vue?vue&type=template&id=8f35b4dc&scoped=true&"
import script from "./InstallAndUpdateManagement.vue?vue&type=script&lang=ts&"
export * from "./InstallAndUpdateManagement.vue?vue&type=script&lang=ts&"
import style0 from "./InstallAndUpdateManagement.vue?vue&type=style&index=0&id=8f35b4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f35b4dc",
  null
  
)

export default component.exports